import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class HistoryService {
    private http = inject(HttpClient);

    async getOrderHistory(filter: any) {
        const buildStart = filter.buildStart ? moment(filter.buildStart).startOf('day').toDate() : filter.buildStart;
        const buildEnd = filter.buildEnd ? moment(filter.buildEnd).startOf('day').toDate() : filter.buildEnd;
        const orderStart = filter.orderStart ? moment(filter.orderStart).startOf('day').toDate() : filter.orderStart;
        const orderEnd = filter.orderEnd ? moment(filter.orderEnd).startOf('day').toDate() : filter.orderEnd;

        return await this.http
            .post<any>(`${environment.serviceName}/history/orderHistory`, {
                orderLineDetailId: filter.orderLineDetailId,
                typeId: filter.typeId,
                dealerId: filter.dealerId,
                partNumber: filter.partNumber,
                vin: filter.vin,
                buildStart: buildStart,
                buildEnd: buildEnd,
                orderStart: orderStart,
                orderEnd: orderEnd,
                includeDeleted: filter.includeDeleted,
                salesOrderNumber: filter.salesOrderNumber,
                detailIds: filter.detailIds,
                packingSlipNumber: filter.packingSlipNumber,
            })
            .toPromise();
    }

    async getPurchaseOrderHistory(filter: any) {
        const deliveryStart = filter.deliveryStart ? moment(filter.deliveryStart).startOf('day').toDate() : filter.deliveryStart;
        const deliveryEnd = filter.deliveryEnd ? moment(filter.deliveryEnd).startOf('day').toDate() : filter.deliveryEnd;
        const createdStart = filter.createdStart ? moment(filter.createdStart).startOf('day').toDate() : filter.createdStart;
        const createdEnd = filter.createdEnd ? moment(filter.createdEnd).startOf('day').toDate() : filter.createdEnd;
        return await this.http
            .post<any>(`${environment.serviceName}/history/purchaseOrderHistory`, {
                poNumber: filter.poNumber,
                vendorId: filter.vendorId,
                statusId: filter.statusId,
                partNumber: filter.partNumber,
                deliveryStart: deliveryStart,
                deliveryEnd: deliveryEnd,
                createdStart: createdStart,
                createdEnd: createdEnd,
                includeDeleted: filter.includeDeleted,
            })
            .toPromise();
    }

    async getInvoiceHistory(filter: any) {
        const createdStart = filter.createdStart ? moment(filter.createdStart).startOf('day').toDate() : filter.createdStart;
        const createdEnd = filter.createdEnd ? moment(filter.createdEnd).startOf('day').toDate() : filter.createdEnd;
        const invoiceStart = filter.invoiceStart ? moment(filter.invoiceStart).startOf('day').toDate() : filter.invoiceStart;
        const invoiceEnd = filter.invoiceEnd ? moment(filter.invoiceEnd).startOf('day').toDate() : filter.invoiceEnd;
        const paidStart = filter.paidStart ? moment(filter.paidStart).startOf('day').toDate() : filter.paidStart;
        const paidEnd = filter.paidEnd ? moment(filter.paidEnd).startOf('day').toDate() : filter.paidEnd;
        return await this.http
            .post<any>(`${environment.serviceName}/history/invoiceHistory`, {
                dealerId: filter.dealerId,
                invoiceNumber: filter.invoiceNumber,
                orderNumber: filter.orderNumber,
                partNumber: filter.partNumber,
                vin: filter.vin,
                packingSlipNumber: filter.packingSlipNumber,
                orderLineDetailId: filter.orderLineDetailId,
                createdStart: createdStart,
                createdEnd: createdEnd,
                invoiceStart: invoiceStart,
                invoiceEnd: invoiceEnd,
                paidStart: paidStart,
                paidEnd: paidEnd,
                includeDeleted: filter.includeDeleted,
            })
            .toPromise();
    }

    async getPackSlipHistory(filter: any) {
        const createdStart = filter.createdStart ? moment(filter.createdStart).startOf('day').toDate() : filter.createdStart;
        const createdEnd = filter.createdEnd ? moment(filter.createdEnd).startOf('day').toDate() : filter.createdEnd;
        return await this.http
            .post<any>(`${environment.serviceName}/history/packingSlipHistory`, {
                dealerId: filter.dealerId,
                invoiceNumber: filter.invoiceNumber,
                orderNumber: filter.orderNumber,
                partNumber: filter.partNumber,
                vin: filter.vin,
                packingSlipNumber: filter.packingSlipNumber,
                orderLineDetailId: filter.orderLineDetailId,
                createdStart: createdStart,
                createdEnd: createdEnd,
                includeDeleted: filter.includeDeleted,
            })
            .toPromise();
    }

    async getDeliveryHistory(filter: any) {
        const scheduledStart = filter.scheduledStart ? moment(filter.scheduledStart).startOf('day').toDate() : filter.scheduledStart;
        const scheduledEnd = filter.scheduledEnd ? moment(filter.scheduledEnd).startOf('day').toDate() : filter.scheduledEnd;
        const completedStart = filter.completedStart ? moment(filter.completedStart).startOf('day').toDate() : filter.completedStart;
        const completedEnd = filter.completedEnd ? moment(filter.completedEnd).startOf('day').toDate() : filter.completedEnd;
        return await this.http
            .post<any>(`${environment.serviceName}/history/deliveryHistory`, {
                deliveryId: filter.deliveryId,
                dealerId: filter.dealerId,
                driverId: filter.driverId,
                truckId: filter.truckId,
                trailerId: filter.trailerId,
                transportPlateId: filter.transportPlateId,
                vin: filter.vin,
                scheduledStart,
                scheduledEnd,
                completedStart,
                completedEnd,
                includeDeleted: filter.includeDeleted,
            })
            .toPromise();
    }

    async getPaymentHistory(filter: any) {
        const paymentStart = filter.paymentStart ? moment(filter.paymentStart).startOf('day').toDate() : filter.paymentStart;
        const paymentEnd = filter.paymentEnd ? moment(filter.paymentEnd).startOf('day').toDate() : filter.paymentEnd;
        const readyToExportStart = filter.readyToExportStart ? moment(filter.readyToExportStart).startOf('day').toDate() : filter.readyToExportStart;
        const readyToExportEnd = filter.readyToExportEnd ? moment(filter.readyToExportEnd).startOf('day').toDate() : filter.readyToExportEnd;
        const exportedStart = filter.exportedStart ? moment(filter.exportedStart).startOf('day').toDate() : filter.exportedStart;
        const exportedEnd = filter.exportedEnd ? moment(filter.exportedEnd).startOf('day').toDate() : filter.exportedEnd;
        return await this.http
            .post<any>(`${environment.serviceName}/history/paymentHistory`, {
                paymentId: filter.paymentId,
                dealerId: filter.dealerId,
                orderNumber: filter.orderNumber,
                invoiceNumber: filter.invoiceNumber,
                referenceNumber: filter.referenceNumber,
                methodId: filter.methodId,
                paymentStart,
                paymentEnd,
                readyToExportStart,
                readyToExportEnd,
                exportedStart,
                exportedEnd,
                includeDeleted: filter.includeDeleted,
            })
            .toPromise();
    }

    async getConfirmationHistory(filter: any) {
        return await this.http
            .post<any>(`${environment.serviceName}/history/confirmationHistory`, {
                dealerId: filter.dealerId,
                code: filter.code,
                includeDeleted: filter.includeDeleted
            })
            .toPromise();
    }
}
